import React, { useState } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Stack,
  Select as SelectChakra,
  Textarea,
  HStack,
  Text,
  Tag,
  Wrap,
  WrapItem,
  TagLabel,
  TagCloseButton,
  Switch,
  Box,
} from '@chakra-ui/react';
import { Select } from 'chakra-react-select';
import { useDispatch } from 'react-redux';
import { createMateria } from '../../features/materiaSlice';

const ModalAgregarMateria = ({ grados, docentes, sede }) => {
  const dispatch = useDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);

  // descripcionComportamental para cursos comportamentales
  const [descripcionComportamental, setdescripcionComportamental] = useState(
    []
  );
  const [valoracion, setValoracion] = useState({
    id: '',
    text: '',
  });

  const initialValues = {
    nombre: '',
    brand_color: '#000000',
    descripcion: '',
    orden: '',
    grado: null,
    docente: null,
    sede: sede,
    descripcionComportamental: [],
    intensidadHorariaSemanal: 0,
    esComportamental: false,
    estado: '',
  };

  const [indice, setIndice] = useState(initialValues);

  const handleModalOpen = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setIndice(initialValues);
    setdescripcionComportamental([]);
  };

  const handleSave = () => {
    dispatch(createMateria(indice));
    setIsModalOpen(false);
    setIndice(initialValues);
    setdescripcionComportamental([]);
  };

  const colorOptions = [
    { label: 'ROJO', value: '#FF5733' },
    { label: 'VERDE', value: '#33FF57' },
    { label: 'AZUL', value: '#3357FF' },
    { label: 'AMARILLO', value: '#FFD700' },
    { label: 'ROSADO', value: '#FF69B4' },
    { label: 'VIOLETA', value: '#8A2BE2' },
    { label: 'TURQUESA', value: '#00CED1' },
    { label: 'NARANJA', value: '#FFA500' },
    { label: 'MARRÓN', value: '#A52A2A' },
    { label: 'GRIS OSCURO', value: '#2F4F4F' },
    { label: 'CUSTOM', value: '#000000' },
  ];

  const handleAddValoracion = () => {
    if (
      descripcionComportamental.length < 10 &&
      valoracion.text.trim() !== ''
    ) {
      setdescripcionComportamental([
        ...descripcionComportamental,
        { id: Date.now(), text: valoracion.text },
      ]);
      setValoracion({ id: '', text: '' });
      setIndice({
        ...indice,
        descripcionComportamental: [
          ...descripcionComportamental,
          { id: Date.now(), text: valoracion.text },
        ],
      });
    }
  };

  const handleRemoveValoracion = id => {
    const updateddescripcionComportamental = descripcionComportamental.filter(
      it => it.id !== id
    );
    setdescripcionComportamental(updateddescripcionComportamental);
    setIndice({
      ...indice,
      descripcionComportamental: updateddescripcionComportamental,
    });
  };

  return (
    <>
      <Button
        colorScheme="primary"
        _dark={{
          bg: 'primary.100',
          color: 'white',
          _hover: { bg: 'primary.300' },
        }}
        onClick={handleModalOpen}
        variant="solid"
        rounded={'xl'}
      >
        REGISTRAR NUEVA ASIGNATURA
      </Button>
      <Modal isOpen={isModalOpen} onClose={handleModalClose} size="full">
        <ModalOverlay
          bg="rgba(11,15,25, 0.8)"
          backdropFilter="auto"
          backdropBlur="2px"
        />
        <ModalContent _dark={{ bg: 'primary.1000' }}>
          <ModalHeader textAlign="center">
            REGISTRAR NUEVA MATERIA ASIGNATURA
          </ModalHeader>
          <ModalCloseButton size="lg" />
          <ModalBody>
            <Stack
              spacing={4}
              direction="column"
              justifyContent="space-between"
            >
              <Stack
                spacing={4}
                direction={['column', 'column', 'row']}
                justifyContent={'space-between'}
              >
                <FormControl isRequired>
                  <FormLabel fontWeight="semibold">NOMBRE</FormLabel>
                  <Input
                    placeholder="Nombre del Curso"
                    type="text"
                    onChange={e =>
                      setIndice({ ...indice, nombre: e.target.value })
                    }
                  />
                </FormControl>
                <FormControl>
                  <FormLabel fontWeight="semibold">COLOR</FormLabel>
                  <Select
                    options={colorOptions}
                    value={colorOptions.find(
                      c => c.value === indice.brand_color
                    )}
                    onChange={option =>
                      setIndice({ ...indice, brand_color: option.value })
                    }
                    isSearchable={false}
                    getOptionLabel={e => (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                        }}
                      >
                        <div
                          style={{
                            width: 12,
                            height: 12,
                            borderRadius: '50%',
                            backgroundColor: e.value,
                          }}
                        />
                        {e.label}
                      </div>
                    )}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel fontWeight="semibold">N. ORDEN</FormLabel>
                  <Input
                    type="number"
                    onChange={e =>
                      setIndice({ ...indice, orden: e.target.value })
                    }
                    placeholder="Orden del Curso"
                  />
                </FormControl>
              </Stack>

              <Stack spacing={4} direction="row" justifyContent="space-between">
                <FormControl>
                  <FormLabel fontWeight="semibold">DESCRIPCIÓN</FormLabel>
                  <Textarea
                    placeholder="Descripción del Curso"
                    rows={2}
                    onChange={e =>
                      setIndice({ ...indice, descripcion: e.target.value })
                    }
                  />
                </FormControl>
              </Stack>

              {/* Switch para curso comportamental */}
              <Box
                p={4}
                borderWidth="2px"
                borderRadius="lg"
                borderColor={
                  indice.esComportamental ? 'primary.500' : 'gray.200'
                }
                bg={indice.esComportamental ? 'primary.50' : 'transparent'}
                _dark={{
                  borderColor: indice.esComportamental
                    ? 'primary.300'
                    : 'gray.600',
                  bg: indice.esComportamental ? 'primary.900' : 'transparent',
                }}
              >
                <FormControl display="flex" alignItems="center">
                  <FormLabel
                    htmlFor="es-comportamental"
                    mb="0"
                    fontWeight="bold"
                  >
                    ¿Es un curso comportamental?
                  </FormLabel>
                  <Switch
                    id="es-comportamental"
                    size="lg"
                    colorScheme="primary"
                    isChecked={indice.esComportamental}
                    onChange={e => {
                      setIndice({
                        ...indice,
                        esComportamental: e.target.checked,
                      });
                      // Limpiar campos cuando cambia el modo
                      if (e.target.checked) {
                        setIndice({
                          ...indice,
                          esComportamental: true,
                          intensidadHorariaSemanal: 0,
                        });
                      } else {
                        setdescripcionComportamental([]);
                        setIndice({
                          ...indice,
                          esComportamental: false,
                          descripcionComportamental: [],
                        });
                      }
                    }}
                  />
                </FormControl>
                {indice.esComportamental && (
                  <Text
                    fontSize="sm"
                    color="gray.600"
                    _dark={{ color: 'gray.400' }}
                    mt={2}
                  >
                    Los cursos comportamentales solo requieren
                    descripcionComportamental cualitativas
                  </Text>
                )}
              </Box>

              {/* Campos condicionales según el tipo de curso */}
              {!indice.esComportamental ? (
                <>
                  <Stack
                    spacing={4}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <FormControl>
                      <FormLabel fontWeight="semibold">GRADO</FormLabel>
                      <SelectChakra
                        placeholder="Seleccione el grado"
                        onChange={e =>
                          setIndice({ ...indice, grado: e.target.value })
                        }
                        defaultValue={indice ? indice.grado : ''}
                      >
                        <option value="all">TODOS LOS GRADOS</option>
                        {grados.map(grado => (
                          <option key={grado._id} value={grado._id}>
                            {grado.nombre} - {grado.nivel}
                          </option>
                        ))}
                      </SelectChakra>
                    </FormControl>
                    <FormControl>
                      <FormLabel fontWeight="semibold">
                        INTENSIDAD HORARIA SEMANAL
                      </FormLabel>
                      <Input
                        placeholder="Intensidad horaria semanal"
                        type="number"
                        onChange={e =>
                          setIndice({
                            ...indice,
                            intensidadHorariaSemanal: e.target.value,
                          })
                        }
                      />
                    </FormControl>
                  </Stack>

                  <Stack
                    spacing={4}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <FormControl>
                      <FormLabel fontWeight="semibold">
                        ASIGNAR DOCENTE
                      </FormLabel>
                      <SelectChakra
                        placeholder="Seleccione el docente"
                        onChange={e =>
                          setIndice({ ...indice, docente: e.target.value })
                        }
                        defaultValue={indice ? indice.docente : ''}
                      >
                        {docentes.map(docente => (
                          <option key={docente._id} value={docente._id}>
                            {docente.nombre}
                          </option>
                        ))}
                      </SelectChakra>
                    </FormControl>
                  </Stack>

                  <Stack
                    spacing={4}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <FormControl isRequired alignSelf={'center'}>
                      <FormLabel fontWeight={'semibold'}>ESTADO</FormLabel>
                      <RadioGroup
                        onChange={e => setIndice({ ...indice, estado: e })}
                        defaultChecked={indice ? indice.estado : ''}
                        colorScheme="primary"
                        size="lg"
                      >
                        <Stack direction="row">
                          <Radio value="activo">Activo</Radio>
                          <Radio value="inactivo">Inactivo</Radio>
                        </Stack>
                      </RadioGroup>
                    </FormControl>
                  </Stack>
                </>
              ) : (
                <>
                  {/* Sección de descripcionComportamental para cursos comportamentales - Solo Grado y descripcionComportamental */}
                  <Stack
                    spacing={4}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <FormControl>
                      <FormLabel fontWeight="semibold">GRADO</FormLabel>
                      <SelectChakra
                        placeholder="Seleccione el grado"
                        onChange={e =>
                          setIndice({ ...indice, grado: e.target.value })
                        }
                        defaultValue={indice ? indice.grado : ''}
                      >
                        <option value="all">TODOS LOS GRADOS</option>
                        {grados.map(grado => (
                          <option key={grado._id} value={grado._id}>
                            {grado.nombre} - {grado.nivel}
                          </option>
                        ))}
                      </SelectChakra>
                    </FormControl>
                  </Stack>
                  <Stack
                    spacing={4}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <FormControl>
                      <FormLabel fontWeight="semibold">
                        ASIGNAR DOCENTE
                      </FormLabel>
                      <SelectChakra
                        placeholder="Seleccione el docente"
                        onChange={e =>
                          setIndice({ ...indice, docente: e.target.value })
                        }
                        defaultValue={indice ? indice.docente : ''}
                      >
                        {docentes.map(docente => (
                          <option key={docente._id} value={docente._id}>
                            {docente.nombre}
                          </option>
                        ))}
                      </SelectChakra>
                    </FormControl>
                  </Stack>

                  <Stack spacing={4}>
                    <FormControl>
                      <FormLabel fontWeight="semibold">
                        Descripcion Comportamental{' '}
                        <Text as="span" fontWeight="normal">
                          ({descripcionComportamental.length}/4)
                        </Text>
                      </FormLabel>

                      <HStack>
                        <Input
                          placeholder="Escribe una descripcion del comportamiento para la materia"
                          type="text"
                          value={valoracion.text}
                          onChange={e =>
                            setValoracion({
                              ...valoracion,
                              text: e.target.value,
                            })
                          }
                          onKeyDown={e => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              handleAddValoracion();
                            }
                          }}
                          aria-label="input-valoracion"
                        />
                        <Button
                          colorScheme="primary"
                          onClick={handleAddValoracion}
                          isDisabled={descripcionComportamental.length >= 4}
                        >
                          Agregar
                        </Button>
                      </HStack>
                    </FormControl>

                    {descripcionComportamental.length > 0 && (
                      <Wrap>
                        {descripcionComportamental.map(val => (
                          <WrapItem key={val.id}>
                            <Tag
                              size="lg"
                              borderRadius="full"
                              variant="solid"
                              colorScheme="primary"
                            >
                              <TagLabel>{val.text}</TagLabel>
                              <TagCloseButton
                                onClick={() => handleRemoveValoracion(val.id)}
                                aria-label={`Eliminar ${val.text}`}
                              />
                            </Tag>
                          </WrapItem>
                        ))}
                      </Wrap>
                    )}
                  </Stack>
                </>
              )}
            </Stack>
          </ModalBody>
          <ModalFooter>
            <Button
              size="lg"
              mr={3}
              onClick={handleModalClose}
              borderRadius="xl"
            >
              CANCELAR
            </Button>
            <Button
              bg="primary.100"
              color="white"
              _hover={{ bg: 'primary.200' }}
              _dark={{
                bg: 'primary.100',
                color: 'white',
                _hover: { bg: 'primary.200' },
              }}
              size="lg"
              mr={3}
              onClick={handleSave}
              isDisabled={indice.nombre === '' || indice.grado === ''}
              borderRadius="xl"
            >
              GUARDAR
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalAgregarMateria;
